// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import utilsModel from "../../../../engines/libs/utilsModel";
import { GAME_MODE } from "../../../../engines/managers/gameContent/gameMode_json";
import { UIKind } from "../../../define/UIKind";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class GameEndEventLayer extends BasePopUpLayer {

	@property({ type: cc.Node, displayName:'' })
	nodeFrontier: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeDie: cc.Node = null;

   

    // LIFE-CYCLE CALLBACKS:

    onLoad () {
        // NormalGameManager._instance.pauseTimer();
        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.GameEndEventLayer);
    }

    // protected onDestroy(): void {
    //     // NormalGameManager._instance.resumeTimer();
        

    // }

    start () {
        let bPushDieJail = this._carryData.bPushDieJail;

        this.nodeDie.active = bPushDieJail;
        this.nodeFrontier.active = !bPushDieJail;
    }

    onClickResetStart() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();

        this._carryData.parent.closeLayer();
        this.destroyNode();
        NormalGameManager._instance.spliceOneNodeStrs(UIKind.UILayerTag.GameEndEventLayer);

        NormalGameManager._instance.setGameData({gameFail : 0} , false );
        //重新开始
        NormalGameManager._instance.resetManager();
        O1HD.getManagers().gameMgr.selectMode( GAME_MODE.NORMAL ).then();
    }

    onClickResurrection() {
        //看广告
        utilsModel.loadAndShowVideoAdTrans(()=>{
            O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.GameEndEventLayer);
            NormalGameManager._instance.setGameData({gameFail : 0} , false );
            O1HD.getServices().userSrv.setGameFail(0);
            this._carryData.parent.showUI(true);
            this.destroyNode();
        },()=>{

        },null,"看广告购买复活丹复活")
    }

    // update (dt) {}
}
